import env from '../env';
import { getPortalAPIRequestParams } from '../services/PortalAPIServices/helper';

async function fetchServerTime(): Promise<number | null> {
  try {
    const start = Date.now();
    const { url } = getPortalAPIRequestParams('server-time');

    const res = await fetch(url);
    if (!res.ok) throw new Error(`API returned ${res.status}`);

    const json = await res.json();

    const end = Date.now();
    const latency = (end - start) / 2;

    // Convert seconds → ms
    return json.unixTimestamp * 1000 + latency;
  } catch (err) {
    console.warn('WorldTime API failed, falling back or ignoring', err);
    return null;
  }
}

/**
 * Detects clock skew between the user's local time and a reference server time.
 * @param {number} thresholdMinutes - The threshold in minutes for clock skew detection.
 * @returns {Promise<number | boolean>} The difference in milliseconds (positive = local clock is ahead, negative = behind),
 *          or true if clock skew is detected, false if not.
 *          or null if the time check failed.
 */
export const detectClockSkew = async (thresholdMinutes: number = 4): Promise<boolean | null> => {
  const serverTime = await fetchServerTime();
  const localTime = Date.now();
  const diff = localTime - serverTime;
  const isDev = env.NODE_ENV === 'development' || env.NODE_ENV === 'staging';
  console.log('[debug] detectClockSkew', { serverTime, localTime, diff });
  if (serverTime === null && isDev) {
    return false;
  }

  if (serverTime === null) {
    console.warn('[warning] Server time not available, clock skew detection failed');
    return false;
  }

  if (Math.abs(diff) > thresholdMinutes * 60 * 1000) {
    return true;
  }
  return false;
};
